import { CONSORS_SUBSCRIBERS } from 'cpool-constants';
import { z } from 'zod';

import { schemaConsorsBankAccount } from './bankAccount.schema';
import { schemaConsorsPurposeOfLoan } from './purposeOfLoan.schema';
import { schemaConsorsSubscriber } from './subscriber.schema';
import { schemaConsorsSubscriptionIdentifierExternal } from './subscriptionIdentifierExternal.schema';

export const schemaConsorsSubscription = z
    .object({
        bankAccount: schemaConsorsBankAccount,
        externalLoansAmount: z.number().int().min(-1.7976931348623157e308).max(9.99999999e8).optional(),
        isEsigned: z.boolean().optional(),
        isImmediatePayoutOpted: z.boolean().optional(),
        kycPurposeOfLoan: schemaConsorsPurposeOfLoan,
        subscribers: z
            .array(schemaConsorsSubscriber)
            .min(1)
            .max(2)
            .refine(
                (subscribers) => subscribers.some((subscriber) => subscriber.rolePlaying === CONSORS_SUBSCRIBERS.MAIN),
                {
                    message: `At least one subscriber with rolePlaying ${CONSORS_SUBSCRIBERS.MAIN} must exist`,
                },
            ),
        subscriptionIdentifierExternal: schemaConsorsSubscriptionIdentifierExternal.optional(),
    })
    .refine((data) => data.subscribers.length !== 1 || data.bankAccount.accountOwner === CONSORS_SUBSCRIBERS.MAIN, {
        message: `Bank account owner must be ${CONSORS_SUBSCRIBERS.MAIN} when there is only one subscriber`,
    });

export type SchemaConsorsSubscription = z.infer<typeof schemaConsorsSubscription>;
